import { createSlice } from '@reduxjs/toolkit';

const loadFromStorage = () => {
  try {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    if (token && user) {
      const parsed = JSON.parse(user);
      return {
        token,
        user: parsed,
        isAuthenticated: true,
        mustChangePassword: parsed.mustChangePassword || false,
        isAdmin: parsed.isAdmin || false,
        isSuperAdmin: parsed.isSuperAdmin || false,
        canAccessTest: parsed.canAccessTest || false,
        tenantId: parsed.tenantId || null,
        primaryColor: parsed.primaryColor || '#1a1a2e',
        secondaryColor: parsed.secondaryColor || '#2e75b6',
        logoUrl: parsed.logoUrl || null,
        portalTitle: parsed.portalTitle || 'Avixa Portal',
        faviconUrl: parsed.faviconUrl || null,
      };
    }
  } catch (e) {}
  return {};
};

const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
  mustChangePassword: false,
  isAdmin: false,
  isSuperAdmin: false,
  canAccessTest: false,
  tenantId: null,
  primaryColor: '#1a1a2e',
  secondaryColor: '#2e75b6',
  logoUrl: null,
  portalTitle: 'Avixa Portal',
  faviconUrl: null,
  isTestMode: false,
  loading: false,
  error: null,
  ...loadFromStorage(),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.user = action.payload;
      state.token = action.payload.token;
      state.isAuthenticated = true;
      state.mustChangePassword = action.payload.mustChangePassword;
      state.isAdmin = action.payload.isAdmin;
      state.isSuperAdmin = action.payload.isSuperAdmin || false;
      state.canAccessTest = action.payload.canAccessTest;
      state.tenantId = action.payload.tenantId || null;
      state.primaryColor = action.payload.primaryColor || '#1a1a2e';
      state.secondaryColor = action.payload.secondaryColor || '#2e75b6';
      state.logoUrl = action.payload.logoUrl || null;
      state.portalTitle = action.payload.portalTitle || 'Avixa Portal';
      state.faviconUrl = action.payload.faviconUrl || null;
      state.isTestMode = false;
      state.error = null;
      localStorage.setItem('token', action.payload.token);
      localStorage.setItem('user', JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.mustChangePassword = false;
      state.isAdmin = false;
      state.isSuperAdmin = false;
      state.canAccessTest = false;
      state.tenantId = null;
      state.primaryColor = '#1a1a2e';
      state.secondaryColor = '#2e75b6';
      state.logoUrl = null;
      state.portalTitle = 'Avixa Portal';
      state.faviconUrl = null;
      state.isTestMode = false;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
    toggleTestMode: (state) => {
      state.isTestMode = !state.isTestMode;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { loginSuccess, logout, setLoading, setError, clearError, toggleTestMode } = authSlice.actions;
export default authSlice.reducer;